import { createReducer } from '@reduxjs/toolkit'

import * as ActionTypes from 'common/builder/constants/builderReduxActionTypes'
import { DraftTrigger } from 'shared/api/common/schemas/flow/draftTrigger'
import {
  FlowContextConstant,
  FlowContextMeta,
  FlowExternalDependency,
} from 'shared/api/common/schemas/flow/flow'

export interface FlowContextState {
  constants: Record<string, FlowContextConstant>
  meta: FlowContextMeta
  triggers?: DraftTrigger[]
  external?: FlowExternalDependency[]
}
interface ContentParsedAction {
  type: typeof ActionTypes.CONTENT_PARSED
  parsed: {
    context: FlowContextState
  }
}

interface SetFlowContextAction {
  type: typeof ActionTypes.UPDATE_FLOW_CONTEXT
  payload: FlowContextState
}

interface SetFlowContextConstantValueAction {
  type: typeof ActionTypes.UPDATE_FLOW_CONTEXT_CONSTANT_VALUE
  payload: {
    name: string
    value: FlowContextConstant['value']
  }
}

interface UpdateFlowContextTriggersAction {
  type: typeof ActionTypes.UPDATE_FLOW_CONTEXT_TRIGGERS
  payload: DraftTrigger[]
}

interface UpdateFlowContextExternalDependenciesAction {
  type: typeof ActionTypes.UPDATE_FLOW_CONTEXT_EXTERNAL_DEPENDENCIES
  payload: FlowExternalDependency[]
}

const initialState: FlowContextState = {
  constants: {},
  meta: {},
}

const flowContextReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(
      ActionTypes.UPDATE_FLOW_CONTEXT,
      (state: FlowContextState, action: SetFlowContextAction) => {
        state.constants = action.payload.constants
        state.meta = action.payload.meta
        state.triggers = action.payload.triggers
        state.external = action.payload.external
      },
    )
    .addCase(
      ActionTypes.UPDATE_FLOW_CONTEXT_CONSTANT_VALUE,
      (state, action: SetFlowContextConstantValueAction) => {
        if (state.constants[action.payload.name])
          state.constants[action.payload.name].value = action.payload.value
      },
    )
    .addCase(
      ActionTypes.UPDATE_FLOW_CONTEXT_TRIGGERS,
      (state: FlowContextState, action: UpdateFlowContextTriggersAction) => {
        state.triggers = action.payload
      },
    )
    .addCase(
      ActionTypes.UPDATE_FLOW_CONTEXT_EXTERNAL_DEPENDENCIES,
      (state: FlowContextState, action: UpdateFlowContextExternalDependenciesAction) => {
        state.external = action.payload
      },
    )
    .addCase(ActionTypes.CONTENT_PARSED, (state: FlowContextState, action: ContentParsedAction) => {
      if (action.parsed?.context?.constants) {
        state.constants = action.parsed.context.constants
      }

      if (action.parsed?.context?.meta) {
        state.meta = action.parsed.context.meta
      }

      if (action.parsed?.context?.triggers) {
        state.triggers = action.parsed.context.triggers
      }

      if (action.parsed?.context?.external) {
        state.external = action.parsed.context.external
      }
    })
})

export default flowContextReducer
